import type { BibleLocation } from '@skjv/common';

/**
 * URL hash persistence for browser history navigation.
 */

/** Save location to URL hash using replaceState */
export function saveLocationToHash(location: BibleLocation): void {
  if (typeof window === 'undefined') return;

  const { testamentIndex, bookIndex, chapterIndex, verseIndex } = location;
  const hash = `#${testamentIndex}-${bookIndex}-${chapterIndex}-${verseIndex}`;

  if (window.location.hash !== hash) {
    const url = window.location.pathname + window.location.search + hash;
    window.history.replaceState(null, '', url);
  }
}

/** Parse location from URL hash */
export function loadLocationFromHash(): BibleLocation | null {
  if (typeof window === 'undefined') return null;

  const hash = window.location.hash.slice(1);
  if (!hash) return null;

  const parts = hash.split('-').map(Number);
  if (parts.length < 4 || parts.some(isNaN)) return null;

  return {
    testamentIndex: parts[0],
    bookIndex: parts[1],
    chapterIndex: parts[2],
    verseIndex: parts[3],
  };
}
